import { Schema, SchemaTransformation } from 'effect';

// v4 migration notes:
//   * `Schema.compose(A, B)` was renamed to `decodeTo` (per migration/schema.md:19).
//   * `Schema.nonEmptyString` was renamed to `isNonEmpty` and is now applied
//     via `.check(...)` instead of `.pipe(...)`.
//   * v4 annotation `message` accepts `string | undefined` only — the v3
//     intl-aware `() => ({ override, message: Effect<...> })` shape is gone.
//     Messages here use the default (Czech) string; the i18n-aware message
//     override system is tracked separately.

export const String = Schema.String.annotate({
  message: 'Hodnota musí být text',
});

export const StringTrimmed = String.pipe(
  Schema.decodeTo(Schema.Trimmed, SchemaTransformation.trim())
);

export const StringRequired = StringTrimmed.check(
  Schema.isNonEmpty({ message: 'Toto pole je povinné' })
);

export const StreetAndNumberStrict = StringRequired.check(
  Schema.makeFilter(
    (value: string) => {
      // 1) village form without street name: "č. p. 23", "č.p.23", "č.ev. 52", "c.p. 12A"
      const villagePattern = /^(č|c)\s*\.?\s*(p|ev)\.?\s*\d+[A-Za-z]?$/i;
      if (villagePattern.test(value)) {
        return true;
      }

      // 2) street and number (+ optional /number)
      //    "U Zámečku 5A"
      //    "U Zámečku 5A/12B"
      //    "Myslíkova 12/23"
      //    "Náměstí 5. května 12"
      const cityPattern = /^(.+?)\s+(\d+[A-Za-z]?(?:\/\d+[A-Za-z]?)?)$/;
      const match = cityPattern.exec(value);
      if (!match) {
        return false;
      }

      const leftPart = match[1] ?? '';

      // left side (street / location name) has to have at least one letter
      const hasLetter = /[A-Za-zÀ-ž]/.test(leftPart);

      return hasLetter;
    },
    {
      message: 'Vyplňte ulici a číslo popisné!',
    }
  )
);

export const StringOptionalProperty = Schema.optional(String);
